const Layout = () => import(/* webpackChunkName: "Layout" */ "../views/Layout.vue");
const IntegralMall = () => import(/* webpackChunkName: "Eshop" */ "../views/integralMall/Index.vue");
export default [
  {
    path: "/integral-mall",
    component: Layout,
    hidden: true,
    meta: {
      title: "积分商城",
      titleEn: "EshIntegral Mall",
    },
    children: [
      {
        path: "",
        component: IntegralMall,
      },
    ],
  },
];
